import React from "react";
import MilesPointsDashboardHeader from "./MilesPointsDashboardHeader";
import MilesPointsDashboardsRedeemCards from "./MilesPointsDashboardsRedeemCards";
import MilesPointsDashboardTasks from "./MilesPointsDashboardTasks";

function MilesPointsDashboard() {
  return (
    <div className="w-full shadow-md border border-yellow-400 rounded-xl overflow-hidden flex flex-col mt-10 font-main">
      <MilesPointsDashboardHeader />
      <MilesPointsDashboardsRedeemCards />
      <MilesPointsDashboardTasks />
    </div>
  );
}

export default MilesPointsDashboard;
